
import {
  FLUSH,
  PAUSE,
  PURGE,
  PERSIST,
  REGISTER,
  REHYDRATE,
  persistStore,
} from "redux-persist"
import React from "react" 
import { Provider } from "react-redux"
import ReactDOM from "react-dom/client" 
import storage from "redux-persist/lib/storage"
import { configureStore } from "@reduxjs/toolkit"
import { BrowserRouter as Router } from "react-router-dom"
import { PersistGate } from "redux-persist/integration/react"
import { encryptTransform } from "redux-persist-transform-encrypt"
import persistCombineReducers from "redux-persist/es/persistCombineReducers"
import { NextUIProvider } from "@nextui-org/react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { CombinedContext } from "./contexts/CombinedContext.jsx"
import App from "./App.jsx"
import "./index.css"
import {
  authReducer,
  stockReducer,
  ledgerReducer,
  companyReducer,
  grayStockReducer,
  outstandingPayableReducer,
  outstandingReceivableReducer,
  invoiceReducer,
  creditDebitNoteReducer,
  accountReducer,
  itemReducer,
  receiveEntryReducer,
  paymentEntryReducer,
  salesOrderEntryReducer,
  productionReducer,
  beamCardReducer,
  jvEntryReducer,
  saleEntryReducer,
  purchaseEntryReducer,
  challanEntryReducer,
  monthExpEntryReducer,
  masterItemEntryReducer
} from "./state/index.jsx"

const queryClient = new QueryClient()

const presistConfig = {
  key: "root",
  storage,
  version: 1,
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_SECRET_KEY,
      onError: function (error) {},
    }),
  ],
}
const persistedReducer = persistCombineReducers(presistConfig, {
  auth: authReducer,
  ledger: ledgerReducer,
  company: companyReducer,
  grayStock: grayStockReducer,
  stock: stockReducer,
  outstandingPayable: outstandingPayableReducer,
  outstandingReceivable: outstandingReceivableReducer,
  invoice: invoiceReducer,
  cerditDebitNote: creditDebitNoteReducer,
  account:accountReducer,
  item:itemReducer,
  receiveEntry:receiveEntryReducer,
  paymentEntry:paymentEntryReducer,
  saleOrderEntry:salesOrderEntryReducer,
  production:productionReducer,
  beamCard:beamCardReducer,
  jvEntry:jvEntryReducer,
  saleEntry:saleEntryReducer,
  purchaseEntry:purchaseEntryReducer,
  challanEntry:challanEntryReducer,
  monthExpEntry:monthExpEntryReducer,
  masterItemEntry:masterItemEntryReducer
})

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})
export const persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CombinedContext>
          <Router>
            <NextUIProvider>
              <QueryClientProvider client={queryClient}>
                
                <App />
                
              </QueryClientProvider>
            </NextUIProvider>
          </Router>
        </CombinedContext>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)
